import { keys } from "lodash";
import { useCallback } from "react";
import { Line } from "react-chartjs-2";
import { Resource } from "../../../components/loader/resource";
import { usePariticipationSummary } from "../../../store/participations/queries";
import { ParticipationsDTO } from "../../../store/participations/models/dto";
import { chartColours } from "../../../styles/colours";
import { ParticipationsRoutes } from "../../participations/routes";
import { StyledTextWidget } from "./common";

export const RecentParticipationTile = () => (
  <Resource r={usePariticipationSummary()}>
    {useCallback(
      (data: ParticipationsDTO.Responses.GetParticipationSummary.T) => (
        <>
          {keys(data.totalPerWeek).length < 1 ? null : (
            <StyledTextWidget
              title="Recent Participations:"
              center
              to={ParticipationsRoutes.names.ownAll}
            >
              <Line
                data={{
                  labels: data.totalPerWeek.map((x) => x.date),
                  datasets: [
                    {
                      label: "Participations",
                      data: data.totalPerWeek.map((x) => x.count),
                      fill: { target: "start", above: chartColours.blue.light },
                      borderColor: chartColours.blue.main,
                      pointRadius: 1,
                    },
                  ],
                }}
                options={{
                  scales: {
                    y: {
                      min: 0,
                      max: data.maxPerWeek * 1.1,
                    },
                  },
                  elements: {
                    line: {
                      tension: 0.4,
                    },
                  },
                }}
              />
            </StyledTextWidget>
          )}
        </>
      ),
      [chartColours]
    )}
  </Resource>
);
